import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const PropertyTypeIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.0059 8.13435L16.0763 5.20475V1.82056C16.0763 1.20865 15.5804 0.712751 14.9676 0.712751C14.3562 0.712751 13.8603 1.20865 13.8603 1.82056V2.98885L11.679 0.807452C10.6005 -0.270431 8.72543 -0.268519 7.64942 0.809403L0.324313 8.13435C-0.108104 8.56763 -0.108104 9.2687 0.324313 9.70131C0.756925 10.1345 1.45936 10.1345 1.89182 9.70131L9.21622 2.37616C9.45483 2.13881 9.87538 2.13881 10.1127 2.37546L17.4384 9.70131C17.6556 9.91791 17.9388 10.0256 18.2219 10.0256C18.5057 10.0256 18.7893 9.91779 19.0059 9.70131C19.4385 9.26874 19.4385 8.56767 19.0059 8.13435Z"
        fill="currentColor"
      />
      <path
        d="M10.05 4.47886C9.83715 4.26616 9.49256 4.26616 9.28037 4.47886L2.83719 10.9201C2.73547 11.0218 2.6778 11.1606 2.6778 11.3055V16.0035C2.6778 17.106 3.57166 17.9998 4.67405 17.9998H7.86407V13.0595H11.4656V17.9998H14.6556C15.758 17.9998 16.6518 17.106 16.6518 16.0036V11.3055C16.6518 11.1606 16.5947 11.0218 16.4924 10.9201L10.05 4.47886Z"
        fill="currentColor"
      />
    </svg>
  )
})

PropertyTypeIcon.displayName = 'PropertyTypeIcon'
